import React from 'react';
import { Helmet } from 'react-helmet-async';
export default function SEO({title, description, name, type, url}) {
return (
<Helmet>

<title>{title}</title>
<meta name='description' content={description} />
<meta itemprop="description" content={description} />

<meta property="og:title" content={title} />
<meta property="og:site_name" content={name}/>
<meta property="og:url"content={url} />
<meta property="og:description" content={description} />
<meta property="og:type" content={type} />

<meta name="twitter:creator" content={name} />
<meta name="twitter:card" content={type} />
<meta name="twitter:title" content={title} />
<meta name="twitter:description" content={description} />
</Helmet>
)
}